import { UseMutationResult, useMutation } from 'react-query'
import request from '../../request'
import { Dealership } from '../../../lib/types/Dealership'
import { useDealership } from '../../../store/zustand/dealershipStore'

export type VendorAccounts = { ga4_accounts: Array<{ label: string; value: string }> }

export const useEditDealership = (): UseMutationResult<
  unknown,
  unknown,
  {
    data: Partial<Dealership & VendorAccounts>
    id?: string
  },
  unknown
> => {
  const dealership = useDealership()
  return useMutation(
    ({ data, id }: { data: Partial<Dealership & VendorAccounts>; id?: string }) =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${id}`,
        method: 'PATCH',
        data: data,
      }),
  )
}
